import type { Observable } from 'rxjs';

import type { Icon } from './icon-list.type';
import type { BadgeItemType } from './organization.type';

export enum BtnActionEnum {
  CALLBACK = 'interactive',
  URL = 'url',
  LINK = 'link',
}

export type MenuItemType = {
  key: string;
  text: string | Observable<string>;
  icon?: Icon;
  img?: string;
  isDisabled?: boolean;
  selected?: boolean;
  collapsible?: MenuItemType[];
  organizationList?: BadgeItemType[];
  isWarn?: boolean;
  href?: string;
  routerLink?: string;
} & (ActionCallback | ActionURL);

type ActionCallback = {
  action?: {
    type: BtnActionEnum.CALLBACK;
    callbackOrUrl: () => void;
  };
};

type ActionURL = {
  action?: {
    type: BtnActionEnum.URL;
    callbackOrUrl: string | Observable<string>;
  };
};
